import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import TabMenu from "../TabMenu";
import AdminMenu from "../AdminMenu";
import TabMenuWarehouse from "../TabMenuWarehouse";
import ButtonLink from "../../ButtonLink";
import FinanceAdminMenu from "../FinanceAdminMenu";

const CardData = [
  {
    id: 1,
    name: "Store User",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/StoreUser",
  },
  {
    id: 2,
    name: "Store Discount",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/StoreDiscount",
  },
  {
    id: 3,
    name: "Store Charges",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/price-tag.png",
    backgroundColor: "#F5C621",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/StoreCharges",
  },
  {
    id: 4,
    name: "Store Price Code",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/StorePriceCode",
  },
  {
    id: 5,
    name: "Store Printers",
    icon: "images/printer.png",
    backgroundColor: "#F5C621",
    tintColor: null,
    navigation: "/StorePrinterSetting",
  },
];


const WarehouseData = [
  {
    id: 1,
    name: "Store Printers",
    icon: "images/printer.png",
    backgroundColor: "#F5C621",
    tintColor: null,
    navigation: "/StorePrinterSetting",
  },
];

const FinanceData = [
  {
    id: 1,
    name: "Franchise Management",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/Franchise-List",
  },
];

const AdminData = [
  {
    id: 1,
    name: "User Control",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/UserList",
  },
  {
    id: 2,
    name: "Store Control",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/StoreManagementList",
  },
  {
    id: 3,
    name: "Warehouse Control",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png",
    backgroundColor: "#1F78D9",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/WarehouseManagementList",
  },
  {
    id: 4,
    name: "Charges And Discount",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/price-tag.png",
    backgroundColor: "#F5C621",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/ChargesAndDiscountList",
  },
  {
    id: 5,
    name: "App Services",
    icon: "images/app-development.png",
    backgroundColor: "#AD39BF",
    tintColor: null,
    navigation: "/AppServiceList",
  },
  {
    id: 6,
    name: "Tariff List",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/TariffList",
  },
  {
    id: 7,
    name: "Offers Management",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/price-tag.png",
    backgroundColor: "#1F78D9",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/OffersManagement",
  },
  {
    id: 8,
    // name: "Package Offers Management",
    name: "Store Subscription Management",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/gift.png",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/PackageOfferManagement",
  },
  {
    id: 9,
    name: "Packing Type",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/price-tag.png",
    backgroundColor: "#F5C621",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/GarmentPack",
  },
  {
    id: 10,
    name: "Brand Term & Condition",
    icon: "images/summary.png",
    backgroundColor: "#AD39BF",
    tintColor: null,
    navigation: "/BrandTermAndCondition",
  },
  {
    id: 11,
    name: "Garment Attribute",
    icon: "images/summary.png",
    backgroundColor: "#E63F52",
    tintColor: null,
    navigation: "/GarmentRemarksList",
  },
  {
    id: 12,
    name: "Locality",
    icon: "warehouse/place.png",
    backgroundColor: "#e3e8e5",
    tintColor: null,
    navigation: "/LocalityView",
  },
  {
    id: 13,
    name: "Payment Gateway",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/PaymentGatewayConfigView",
  },
  {
    id: 14,
    name: "Income/Expense",
    icon: "images/increase.png",
    backgroundColor: "#AD39BF",
    tintColor: null,
    navigation: "/Income-expense",
  },
  {
    id: 15,
    name: "Store Printers",
    icon: "images/printer.png",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/StorePrinterSetting",
  },
  {
    id: 16,
    name: "Time Slot Management",
    icon: "images/time-management.png",
    backgroundColor: "#e3e8e5",
    tintColor: null,
    navigation: "/Time-Slot",
  },
  {
    id: 17,
    name: "Loyalty Point Management",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/Loyalty-Point-List",
  },
  {
    id: 18,
    name: "Franchise Management",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/Franchise-List",
  },
  {
    id: 19,
    name: "Brand Images",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png",
    backgroundColor: "#e3e8e5",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/brand-banner-view",
  },
  {
    id: 20,
    name: "Promotion Management",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Store.png",
    backgroundColor: "#1F78D9",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/PromoTemplateView",
  },
  {
    id: 21,
    name: "Payment Mode Management",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/PaymentMode",
  },
  {
    id: 22,
    name: "Switch Store User",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/SwitchRiderUserList",
  },
  {
    id: 23,
    name: "Customer Payment Settlement",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/customer-payment-settlement",
  },
];

const FranchiseAdminData = [
  {
    id: 1,
    name: "Store List",
    icon: "images/increase.png",
    backgroundColor: "#AD39BF",
    tintColor: null,
    navigation: "/franchise-store-list",
  },
  // {
  //   id: 1,
  //   name: "Store Order Revenue",
  //   icon: "images/increase.png",
  //   backgroundColor: "#AD39BF",
  //   tintColor: null,
  //   navigation: "/franchise-store-order-revenue",
  // },
  // {
  //   id: 2,
  //   name: "Store Service Wise Revenue",
  //   icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
  //   backgroundColor: "#1F78D9",
  //   tintColor: null,
  //   navigation: "/franchise-store-service-wise-revenue",
  // },
  {
    id: 3,
    name: "Store Control",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/StoreManagementList",
  },
  {
    id: 4,
    name: "Store Printers",
    icon: "images/printer.png",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/StorePrinterSetting",
  },
];

const Setting = () => {
  const navigate = useNavigate();
  const [modalMenuVisible, setModalMenuVisible] = useState(false);

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  const brandOfferModal = brandProfileData.brandOffModel;
  const enabledLocality = brandProfileData.enabledLocality;
  const enabledGarmentAttribute = brandProfileData.enabledGarmentAttribute;
  const enabledPaymentGateway = brandProfileData.enabledPaymentGateway;
  const enabledLoyaltyPoint = brandProfileData.enabledLoyaltyPoint;
  const enabledFranchiseModal = brandProfileData.enabledFranchiseModal;
  const enabledWhatsappPromotion = brandProfileData.enabledWhatsappPromotion;
  const enabledSwitchStoreUser = brandProfileData.enabledSwitchStoreUser;

  // Filter CardData based on brandProfileData.wareHouseModel
  const filteredData = brandProfileData.wareHouseModel
    ? brandOfferModal // true
      ? AdminData // check 1
      : AdminData?.filter((item) => item.id !== 7) // check 2
    : brandOfferModal
    ? AdminData?.filter((item) => item.id !== 3)
    : AdminData?.filter((item) => item.id !== 7 && item.id !== 3);

  const filteredFranchiseAdminData = FranchiseAdminData;

  const filteredAdminData = filteredData
    .filter((item) => enabledLocality || item.id !== 12)
    .filter((item) => enabledGarmentAttribute || item.id !== 11)
    .filter((item) => enabledPaymentGateway || item.id !== 13)
    .filter((item) => enabledLoyaltyPoint || item.id !== 17)
    .filter((item) => enabledFranchiseModal || item.id !== 18)
    .filter((item) => enabledWhatsappPromotion || item.id !== 20)
    .filter((item) => enabledSwitchStoreUser || item.id !== 22)
    .filter((item) => enabledPaymentGateway || item.id !== 23);

  const renderCardItem = () => {
    return CardData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  const renderWarehouseCardItem = () => {
    return WarehouseData?.map((item, index) => {
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  const renderAccountantCardItem = () => {
    return FinanceData?.map((item, index) => {
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };
  

  const renderAdminCardItem = () => {
    return filteredAdminData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  const renderFranchiseAdminCardItem = () => {
    return filteredFranchiseAdminData?.map((item, index) => {
      return (
        <div
          onClick={() => navigate(item.navigation)}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">Setting</p>
            </div>
          </div>

          {userRole !== "BY_WAREHOUSE" && (
            <div className="mx-2 cursor-pointer">
              <img
                src={"Laundy_App_Icons_Gifs/SettingIcons/translate.png"}
                style={{ width: 30 }}
              />
            </div>
          )}

          {userRole !== "BY_WAREHOUSE" && (
            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => setVisible(true)}
            >
              <i
                className="pi pi-bars"
                style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
              ></i>
            </div>
          )}
        </div>
      </div>

      <div className="mx-4 my-3">
        {userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER" ? (
          filteredAdminData?.length ? (
            renderAdminCardItem()
          ) : (
            <p>No admin data available.</p>
          )
        ) : userRole === "BY_STORE" && CardData?.length ? (
          renderCardItem()
        ) : userRole === "BY_FRANCHISE_ADMIN" ? (
          renderFranchiseAdminCardItem()
        ) : userRole === "BY_WAREHOUSE" && CardData?.length ? (
          renderWarehouseCardItem()
        ) : userRole === "BY_ACCOUNTANT" ? (
          renderAccountantCardItem()
        ) : (
          <p>No card data available.</p>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              // width: 100,
              // height: 50,
              alignSelf: "center",
            }}
          />
        </div>
        {/* <StoreLanguage
          setModalLangVisible={setModalLangVisible}
          modalLangVisible={modalLangVisible}
        /> */}
      </div>
      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : userRole === "BY_ACCOUNTANT" ? <FinanceAdminMenu setVisible={setVisible} visible={visible} />
      
      : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      ) }
      {userRole === "BY_WAREHOUSE" ? <TabMenuWarehouse /> : <TabMenu />}
    </div>
  );
};

export default Setting;
